// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20 8.07043C21.3807 8.07043 22.5 9.18972 22.5 10.5704C22.5 11.9511 21.3807 13.0704 20 13.0704L16 13.0704V15.0297C16 15.5609 15.859 16.0825 15.5913 16.5413L13.1824 20.6709C12.4669 21.8974 10.9895 22.4544 9.64242 22.0053L3.55132 19.975C2.32629 19.5666 1.5 18.4202 1.5 17.1289L1.5 9.05523C1.5 8.12382 1.93261 7.24525 2.67087 6.67736L8.95837 1.84082L10.4975 2.8669C11.1718 3.31645 11.5082 4.12852 11.3492 4.92323L10.7198 8.07043L20 8.07043Z"}}]};

const GestureRightFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'gesture-right-filled',
    ref,
    icon: element,
  },
));

GestureRightFilledIcon.displayName = 'GestureRightFilledIcon';

export default GestureRightFilledIcon;
